$(function () {
    console.log("Document ready");

    function saveNinjaFormDataFirstStep() {
        let ninjaFormData = {};

        // List of field names
        let fieldNames = ['fname', 'lname', 'email', 'phone', 'nf-field-1271'];

        fieldNames.forEach(fieldName => {
            let elements = document.getElementsByName(fieldName);

            if (elements.length > 0) {
                // Assuming it's always the first element you want
                ninjaFormData[fieldName] = elements[0].value;
            } else {
                // Handle the case where the element is not found
                console.warn(`Element with name '${fieldName}' not found.`);
                ninjaFormData[fieldName] = ''; // Set a default value or handle as needed
            }
        });

        sessionStorage.setItem('ninjaFormData', JSON.stringify(ninjaFormData));
        console.log(sessionStorage.getItem('ninjaFormData'));
    }

    // Event listener for input events on specified fields
    $('body').on('input', 'input[name="fname"], input[name="lname"], input[name="email"], input[name="phone"], input[name="nf-field-1271"]', function() {
        saveNinjaFormDataFirstStep();
    });    

    //FILING STORED DATA TO FIELDS IN BOOKNETIC STEPS
    // Function to populate the form fields
    function populateFormFields() {
        // Retrieve data from sessionStorage
        let storedData = JSON.parse(sessionStorage.getItem('ninjaFormData'));
    
        if (storedData) {
            // Map the sessionStorage keys to the new form's input names or IDs
            let fieldMappings = {
                'fname': '#bkntc_input_name',
                'lname': '#bkntc_input_surname',
                'email': '#bkntc_input_email',
                'phone': '#bkntc_input_phone',
                // Assuming 'nf-field-1271' is for the country (adjust as needed)
                'nf-field-1271': '[data-input-id="2"]'
            };
    
            // Populate the fields if they exist
            for (let key in fieldMappings) {
                if (storedData[key] && $(fieldMappings[key]).length) {
                    $(fieldMappings[key]).val(storedData[key]);
                }
            }
        }
    
        // Set the phone number using intl-tel-input API
        if (storedData['phone']) {
            var iti = window.intlTelInputGlobals.getInstance(document.querySelector("#bkntc_input_phone"));
            iti.setNumber(storedData['phone']);
        }
    }
    
    // Check if the form fields are available
    // Adjust the selector and interval as needed based on your form's behavior
    let checkFormFields = setInterval(function() {
        if ($('#bkntc_input_name').length && $('#bkntc_input_phone').length) {
            populateFormFields();
            clearInterval(checkFormFields);
        }
    }, 500); // Check every 500 milliseconds
    

});
